function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_usuarios_a{fill:#fff;stroke:#707070;}\n      .icon_menu_usuarios_b{clip-path:url(#icon_menu_usuarios_a);}\n      .icon_menu_usuarios_c{fill:#607d8b;}\n      .icon_menu_usuarios_d{fill:#546d79;}"), React.createElement("clipPath", {
  id: "icon_menu_usuarios_a"
}, React.createElement("rect", {
  className: "icon_menu_usuarios_a",
  width: 19,
  height: 19,
  transform: "translate(1796 1243)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_usuarios_b",
  transform: "translate(-1796 -1243)"
}, React.createElement("g", {
  transform: "translate(1798 1243.396)"
}, React.createElement("circle", {
  className: "icon_menu_usuarios_c",
  cx: 3.958,
  cy: 3.958,
  r: 3.958,
  transform: "translate(3.167 0.792)"
}), React.createElement("path", {
  className: "icon_menu_usuarios_c",
  d: "M14.25,14.052v2.771a.6.6,0,0,1-.594.594H.594A.6.6,0,0,1,0,16.823V14.052a3.764,3.764,0,0,1,3.76-3.76H10.49A3.764,3.764,0,0,1,14.25,14.052Z"
}), React.createElement("path", {
  className: "icon_menu_usuarios_d",
  d: "M7.125,10.292H3.76A3.765,3.765,0,0,0,0,14.052v2.771a.594.594,0,0,0,.594.594H7.125Z"
}), React.createElement("path", {
  className: "icon_menu_usuarios_d",
  d: "M7.125.792a3.958,3.958,0,0,0,0,7.917Z"
})));

var SvgUsuario = function SvgUsuario(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsuario, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usuario.f378f0cd.svg";
export { ForwardRef as ReactComponent };